// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconUploadPath = 'M9.293 2.293a1 1 0 0 1 1.32-.083l.094.083 4 4-1.414 1.414L11 5.415V14H9V5.415L6.707 7.707 5.293 6.293l4-4Zm10.494 10.923-1.575-1.232-3.679 4.699a.905.905 0 0 1-.707.317H6.1l-.114-.008a.8.8 0 0 1-.555-.348l-3.644-4.66-1.575 1.232 3.6 4.6.1.14c.494.639 1.315 1.046 2.19 1.044l7.886-.001a2.894 2.894 0 0 0 2.227-1.22l3.572-4.563Z';
var IconUpload = baseIcon('IconUpload', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconUploadPath
});
export default IconUpload;
//# sourceMappingURL=index.js.map